export default __webpack_public_path__ + "media/bundles/App/session/ico-user-e489b45b107e66552f2f8037466ebbc7.svg";